import styled from 'styled-components'

const PageWrapper = styled.main`
  color: ${props => props.theme.primary};

  margin: 0 auto;

  max-width: 100vw;
  width: 100vw;

  padding: 0 ${props => props.theme.pageMargin};

  overflow: hidden; // TODO not sure why it tries to scroll without overflow-y being set to hidden

  @media (min-width: ${props => props.theme.small}) {

  }

`

export default PageWrapper;



// WEBPACK FOOTER //
// ./src/shared/PageWrapper.js